import { CreatorSimpleDto } from "@/lib/lutely-api/gen/dtos/creatorSimpleDto";
import { Link } from "@tanstack/react-router";

interface Props {
  creator: CreatorSimpleDto;
  children?: React.ReactNode;
  className?: string;
  creatorIdOverride?: string; // Optional override for creator ID in the URL
}

export const CreatorLink = ({
  creator,
  children,
  className,
  creatorIdOverride,
}: Props) => {
  return (
    <Link
      to={
        !creatorIdOverride && creator.slug
          ? `/@{$CREATOR_SLUG}`
          : `/creators/$CREATOR_ID`
      }
      params={
        creator.slug
          ? { CREATOR_SLUG: creator.slug }
          : { CREATOR_ID: creatorIdOverride ?? creator.creatorId }
      }
      className={className}
    >
      {children}
    </Link>
  );
};
